// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"af7ea639","297":"71da5b03","496":"cbfe37c5","643":"e9190d87"}[chunkId] + ".chunk.js";
};